<template>
	<div class="full-screen" v-if="showIcon">
		<el-tooltip 
		:content="value ? '退出全屏' : '全屏'"
		placement="top"
		:open-delay="500"
		>
			<i 
			class="icon"
			:class="value ? 'icon-fullscreen-exit' : 'icon-fullscreen-enter'"
			@click="handleChange"
			>
			</i>
		</el-tooltip>
	</div>
</template>

<script>
export default {
	name: 'full-screen',
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		showIcon() {
			return window.navigator.userAgent.indexOf('MSIE') < 0;
		}
	},
	mounted() {
		let isFullscreen =
			document.fullscreenElement ||
			document.mozFullScreenElement ||
			document.webkitFullscreenElement ||
			document.fullScreen ||
			document.mozFullScreen ||
			document.webkitIsFullScreen;
		isFullscreen = !!isFullscreen;
		document.addEventListener('fullscreenchange', () => {
			this.$emit('input', !this.value);
			this.$emit('on-change', !this.value);
		});
		document.addEventListener('mozfullscreenchange', () => {
			this.$emit('input', !this.value);
			this.$emit('on-change', !this.value);
		});
		document.addEventListener('webkitfullscreenchange', () => {
			this.$emit('input', !this.value);
			this.$emit('on-change', !this.value);
		});
		document.addEventListener('msfullscreenchange', () => {
			this.$emit('input', !this.value);
			this.$emit('on-change', !this.value);
		});
		this.$emit('input', isFullscreen);
	},
	methods: {
		handleFullscreen() {
			let main = document.body;
			if (this.value) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			} else {
				if (main.requestFullscreen) {
					main.requestFullscreen();
				} else if (main.mozRequestFullScreen) {
					main.mozRequestFullScreen();
				} else if (main.webkitRequestFullScreen) {
					main.webkitRequestFullScreen();
				} else if (main.msRequestFullscreen) {
					main.msRequestFullscreen();
				}
			}
		},
		handleChange() {
			this.handleFullscreen();
		}
	}
};
</script>

<style lang="scss" scoped>
.full-screen {
	padding-left: 15px;
	i {
		cursor: pointer;
	}
}
</style>
